import React from 'react';

import FileUpload from '../../../../components/FileUpload/FileUploader';

import dictionarystreet from '../data/addresses.json';

import AddressFull from './Autocomplete/AddressFull';

import DateSplit from '../widgets/date';

import RadioWidgetPlain from './RadioWidget/radiowidget';

import {loadFileAsBase64} from '../../../../services/apiClient';


const handleFileViewRequest = async (id, fileId, fileIndex) => {

  const url = `requests/${id}/file/${fileId}/cert`;

  try {
    const response = await loadFileAsBase64 (url);
    return response; 
  } catch (error) {
    console.error('Ошибка загрузки файла:', error);
    throw error;
  }
};


const Step1 = ({ formData, errors, onChange }) => {

  return (
    <div className="form-section">
      <h2 className="form-section-title">Дані дитини</h2>
      
      <div className="form-row-plain single">
        <div className="form-group">
          <label className="form-label">Прізвище дитини</label>
          <input
            type="text"
            className={`form-control ${errors.childLastName ? 'is-invalid' : ''}`}
            placeholder="Коваленко"
            value={formData.child.lastName}
            onChange={(e) => onChange('child.lastName', e.target.value)}
          />
          {errors.childLastName && <div className="invalid-feedback">{errors.childLastName}</div>}
        </div>
      </div>
      
      <div className="form-row-plain two-cols">
        <div className="form-group">
          <label className="form-label">Ім'я дитини</label>
          <input
            type="text"
            className={`form-control ${errors.childFirstName ? 'is-invalid' : ''}`}
            placeholder="Софія"
            value={formData.child.firstName}
            onChange={(e) => onChange('child.firstName', e.target.value)}
          />
          {errors.childFirstName && <div className="invalid-feedback">{errors.childFirstName}</div>}
        </div>
        <div className="form-group">
          <label className="form-label">По батькові дитини (залиште пустим, якщо немає)</label>
          <input
            type="text"
            className="form-control"
            placeholder="Романівна"
            value={formData.child.middleName}
            onChange={(e) => onChange('child.middleName', e.target.value)}
          />
        </div>
      </div>


    <DateSplit id={'r-formData.child.birthdate'} error={errors.childBirthDate} date={formData.child.birthDate} setDate={(v)=>onChange('child.birthDate', v)} yearFrom = {2017}  yearTo = {2025} label="Дата народження" />

    <RadioWidgetPlain id={'r-formData.child.gender'} value={formData.child.gender} variants={["girl","boy"]} labels={["Дівчинка","Хлопчик"]} title='Стать дитини' onChange={(d)=>onChange('child.gender', d)} />

     
      <hr className="section-divider" />

      <h2 className="form-section-title">Адреса проживання дитини</h2>

      <AddressFull dictionary={formData.dictionary}  title='Зареєстроване місце проживання' value={formData.child.address} fieldsPath= 'child.address' onChange={onChange} error={errors.childaddress} />

      <RadioWidgetPlain id={'r-formData.child.sameFactAddress'} value={formData.child.sameFactAddress}  title='Фактичне місце проживання дитини відповідає зареєстрованому місцю проживання?' onChange={(d)=>onChange('child.sameFactAddress', d)} />
      
      {formData.child.sameFactAddress == "no" && <AddressFull dictionary={formData.dictionary}  title='Фактичне місце проживання' value={formData.child.addressFact} fieldsPath= 'child.addressFact' onChange={onChange} error={errors.childaddressFact} />}

      
      <h2 className="form-section-title">Дані свідоцтва про народження</h2>
      
      <div className="form-row-plain single">
        <div className="form-group">
          <label className="form-label">Серія та номер</label>
          <input
            type="text"
            className={`form-control ${errors.childCertificate ? 'is-invalid' : ''}`}
            placeholder="I-БК-368568"
            value={formData.child.birthCertificate.seriesNumber}
            onChange={(e) => onChange('child.birthCertificate.seriesNumber', e.target.value)}
          />
          {errors.childCertificate && <div className="invalid-feedback">{errors.childCertificate}</div>}
        </div>
      </div>
      
      <DateSplit id={'r-formData.child.issuedate'}  error={errors.childCertificateDate} date={formData.child.birthCertificate.issueDate} setDate={(v)=>onChange('child.birthCertificate.issueDate', v)} yearFrom = {2017}  yearTo = {2025} label="Дата видачі свідоцтва" />
      

    <RadioWidgetPlain id={'r-formData.child.birthCertificate.country'} value={formData.child.birthCertificate.country} variants={["ua","other"]} labels={["Україна","Іноземна держава"]} title='Країна, що видала свідоцтво' onChange={(d)=>onChange("child.birthCertificate.country", d)}/>

    <FileUpload
                label='Завантажте фото чи скан-копію документа'  
                value={formData.child.birthCertificate.files} 
                onChange={(files)=>onChange('child.birthCertificate.files', files)} 
                onBlur={(files)=>onChange('child.birthCertificate.files', files)} 
                onFocus={(files)=>onChange('child.birthCertificate.files', files)}
                multiple={true}
                errorVal={errors.childCertificateScan}
                description='Один або кілька файлів у форматі PDF, JPG, PNG. Максимальний розмір файлу 5 МБ.'
                maxSize={5 * 1024 * 1024}
                onFileViewRequest={(fileId, fileIndex)=>handleFileViewRequest(formData._id, fileId, fileIndex)}
                />
    </div>
  );
};

export default Step1;